import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#09090B] text-white">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1 flex flex-col items-center text-center">
            <div className="mb-4">
              <img src="/logo-icon.svg" alt="JSY" className="w-16 h-16 invert object-contain" />
            </div>
            <p className="text-sm text-[#71717A] leading-relaxed">
              We deliver excellence with simplicity. Premium plastic packaging and printing solutions for the textile industry, based in Kolkata, West Bengal.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-[#71717A] mb-5">Quick Links</h4>
            <nav className="space-y-3">
              {[
                { to: "/about", label: "About Us" },
                { to: "/products", label: "Products" },
                { to: "/infrastructure", label: "Infrastructure" },
                { to: "/gallery", label: "Gallery" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <Link key={l.to} to={l.to} className="block text-sm text-[#A1A1AA] hover:text-white transition-colors duration-200">
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-[#71717A] mb-5">Products</h4>
            <nav className="space-y-3">
              {["BOPP Bags", "Polyester Sheets", "Readymade Packaging"].map((p) => (
                <Link key={p} to={`/products?category=${encodeURIComponent(p)}`} className="block text-sm text-[#A1A1AA] hover:text-white transition-colors duration-200">
                  {p}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-medium tracking-[0.2em] uppercase text-[#71717A] mb-5">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone size={14} className="text-[#1D4ED8] mt-1 flex-shrink-0" />
                <div>
                  <p className="text-sm text-[#A1A1AA]">+91 7003670034</p>
                  <p className="text-sm text-[#A1A1AA]">+91 7890986920</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail size={14} className="text-[#1D4ED8] mt-1 flex-shrink-0" />
                <p className="text-sm text-[#A1A1AA]">jsypp.2018@gmail.com</p>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={14} className="text-[#1D4ED8] mt-1 flex-shrink-0" />
                <p className="text-sm text-[#A1A1AA]">Budge Budge Trunk Rd, Maheshtala, Kolkata, West Bengal 700141</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
  <div className="border-t border-[#27272A] mt-6 pt-4 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#52525B]">&copy; {new Date().getFullYear()} JSY. All rights reserved.</p>
          <Link to="/contact" className="text-xs text-[#1D4ED8] hover:text-[#3B82F6] flex items-center gap-1 transition-colors duration-200">
            Get a Quotation <ArrowRight size={12} />
          </Link>
        </div>
      </div>
    </footer>
  );
}
